import moment from 'moment'
const US = 'MM dd, yyyy'

export const formatDate = (date, format=US) => {
  if (typeof date === 'string') {
    date = new Date(date)
    return date.format(format)
  }
}

export const formatDateShort = (date) => {
  return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
}

const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export const formatAmount = (amount) => {
  return formatter.format(amount)
}

export const formatTags = (tags) => {
  const t = tags.reduce((a, tag) => {
    return `${a}<div class="tag-cont"><div class="tag-text">${tag.label}</div></div>`
  }, '')
  return `<div class="flex">${t}</div>`
}
